import { useEffect, useRef } from "react";

export default function ContactFooter() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="contact"
      ref={sectionRef}
      className="relative py-24 md:py-32 px-4 md:px-8 lg:px-16"
    >
      <div className="max-w-6xl mx-auto">
        {/* Contact Header */}
        <div className="mb-16 md:mb-20">
          <p className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out text-ding-phosphor font-mono text-sm tracking-widest uppercase mb-4">
            &gt; contact
          </p>
          <h2 className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-100 text-3xl md:text-4xl lg:text-5xl font-bold font-mono text-ding-cream mb-6">
            Let&apos;s build something
          </h2>
          <p className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-200 text-ding-dim text-base md:text-lg">
            Have a project in mind?
          </p>
          <p className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-200 text-ding-dim text-base md:text-lg">
            Need realtime systems, backend services, or developer tooling?
          </p>
          <p className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-200 text-ding-dim text-base md:text-lg">
            Get in touch.
          </p>
          {/* Contact Links */}
          <div className="flex items-center gap-6 mt-6">
            <a
              href="https://www.linkedin.com/company/d-ng-technologies/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-ding-dim hover:text-ding-phosphor transition-colors duration-300"
              aria-label="LinkedIn"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-linkedin-fill text-xl"></i>
              </div>
            </a>
            <a
              href="https://github.com/ding-technologies"
              target="_blank"
              rel="noopener noreferrer"
              className="text-ding-dim hover:text-ding-phosphor transition-colors duration-300"
              aria-label="GitHub"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-github-fill text-xl"></i>
              </div>
            </a>
            <a
              href="mailto:contact@dingtech.dev"
              className="text-ding-dim hover:text-ding-phosphor transition-colors duration-300"
              aria-label="Email"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-mail-line text-xl"></i>
              </div>
            </a>
          </div>
        </div>
                  
      </div>

      {/* Footer */}
      <footer className="mt-24 pt-12 border-t border-ding-lightgray">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="text-sm text-ding-dim">
              <p className="text-ding-phosphor font-mono">d!ng</p>
              <p>Realtime systems & backend engineering</p>
            </div>
          </div>

        <p className="text-ding-phosphor font-mono text-lg mb-4">🚫🤖⌨️</p>
          
        </div>

        <div className="max-w-6xl mx-auto mt-8 pb-8 text-center text-xs text-ding-dim">
          <p> d!ng. All systems operational. Built with &lt;/&gt; and shipped.</p>
        </div>
        <div className="max-w-6xl mx-auto mt-8 pb-8 text-center text-xs text-ding-black">
          <p>Write Code, Not Prompts!</p>
          <p>Code, Don't Manage!</p>
        </div>
      </footer>
    </section>
  );
}